import { render, staticRenderFns } from "./showEventDetails.vue?vue&type=template&id=2920122a&scoped=true"
import script from "./showEventDetails.vue?vue&type=script&lang=js"
export * from "./showEventDetails.vue?vue&type=script&lang=js"
import style0 from "./showEventDetails.vue?vue&type=style&index=0&id=2920122a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2920122a",
  null
  
)

export default component.exports